// extracted by mini-css-extract-plugin
export default {"dot":"ToggleButton_dot__kygA4"};